module.exports = __webpack_public_path__ + "static/media/picnic.de31629c.JPG";